import React from 'react';
import PropTypes from 'prop-types';
import { useTranslate } from 'react-admin';

const IssueCategoryField = ({ source, record = {} }) => {
    const translate = useTranslate();
    return (
        <span>{ translate(`resources.issues.categories.${record[source]}`) } </span>
      );
};

IssueCategoryField.propTypes = {
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

export default IssueCategoryField;
